/**
 * Title-case a snake / kebab / spaced string. Used as the fallback
 * label for rails when no explicit title is set and the server
 * didn't return one either ({@code popular_courses} →
 * {@code Popular Courses}).
 */
export function prettify(s: string | undefined | null): string {
  if (!s) return '';
  return s
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((p) => p[0]!.toUpperCase() + p.slice(1))
    .join(' ');
}
